import React from 'react'

import { Checkbox, TableRow, TableHead as MuiTableHead, Skeleton } from '@mui/material'
import { isFunction } from 'lodash'

import { SortDirection } from '../../types'

import TableCell from './TableCell'
import TableHeadCell from './TableHeadCell'
import { TableHeadItem } from './types'

// ----------------------------------------------------------------------

type TableHeadPropTypes<T> = {
  isLoading?: boolean
  order: SortDirection
  orderBy: string
  rowCount: number
  headLabel: TableHeadItem<T>[]
  numSelected?: number
  size?: 'xs' | 'sm' | 'md' | 'lg'
  onRequestSort: (property: keyof T) => void
  onSelectAllClick?: () => void
}

const TableHead = <T,>({
  isLoading = false,
  order,
  orderBy,
  rowCount,
  headLabel,
  numSelected = 0,
  onRequestSort,
  onSelectAllClick,
  size = 'md',
}: TableHeadPropTypes<T>) => {
  const SelectAllCheckbox = (
    <Checkbox
      indeterminate={numSelected > 0 && numSelected < rowCount}
      checked={rowCount > 0 && numSelected === rowCount}
      onChange={onSelectAllClick}
    />
  )

  return (
    <MuiTableHead>
      <TableRow>
        {isFunction(onSelectAllClick) && (
          <TableCell size={size} padding="checkbox">
            {isLoading ? <Skeleton width={25}>{SelectAllCheckbox}</Skeleton> : SelectAllCheckbox}
          </TableCell>
        )}
        {headLabel.map((headCell) => (
          <TableHeadCell<T>
            key={headCell.id as string}
            size={size}
            data={headCell}
            orderBy={orderBy}
            order={order}
            onRequestSort={onRequestSort}
            isLoading={isLoading}
          />
        ))}
      </TableRow>
    </MuiTableHead>
  )
}

export default TableHead
